/**
 * Personificação vista do admin.
 *
 * O admin nunca INICIA uma personificação -- quem faz isso é o accounts, onde
 * mora o gerenciador de usuários. O admin só *recebe* a sessão já assumida,
 * pela mesma porta de handoff que qualquer outra aplicação usa (ver
 * services/sso.js), e precisa saber exibir o aviso e voltar.
 *
 * Ver a versão irmã em apps/accounts/resources/services/personificacao.js --
 * mesmo par de chaves de localStorage e mesmo formato de claim, porque os dois
 * lados leem o mesmo token.
 */
import { apiRequest } from '@/services/api/apiClient.js';
import { setAuth } from '@/services/api/auth.js';

const CHAVE_ATOR = 'personificando:ator';

/** O login de quem está por trás, ou null quando não há personificação. */
export function atorAtual() {
    return localStorage.getItem(CHAVE_ATOR) || null;
}

export function personificando() {
    return atorAtual() !== null;
}

/**
 * Lê o claim `act` de um token, sem validar assinatura.
 *
 * Seguro ler aqui porque o valor só decide o que a TELA mostra -- quem
 * autoriza de verdade é o backend, que confere o token assinado. Se alguém
 * forjar este campo no navegador, ganha uma faixa de aviso mentirosa e nada
 * mais.
 */
export function lerAtorDoToken(token) {
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload?.act ?? null;
    } catch {
        return null;
    }
}

/** Grava (ou apaga, se `ator` for null) quem está por trás da sessão atual. */
export function marcarAtor(ator) {
    if (ator) {
        localStorage.setItem(CHAVE_ATOR, ator);
    } else {
        localStorage.removeItem(CHAVE_ATOR);
    }
}

/** Volta para a conta de quem personificou. */
export async function voltarParaMim() {
    const resposta = await apiRequest({
        client: window.API_AUTH,
        method: 'post',
        url: '/despersonificar',
    });

    setAuth({
        token: resposta?.access_token,
        credentials: resposta?.credentials,
    });
    marcarAtor(null);

    return resposta;
}
